export default {
    ...require('./en.shared.json')
};
